import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, makeStyles, useTheme } from '@material-ui/core'
import { FormSkeleton, SelectOption } from '@globaleris/ui.library'

import { TradeDetailsResponse } from '../../../api'

import { EnumPriceCalculationType } from '../../../api/Argentia/enums'
import Page from '../../../components/page/page'
import PageHeader from '../../../components/page/pageHeader'

import { storeActiveTrade } from '../../../redux'
import { checkTradeSimple, getTradeDetails } from '../trades.service'

import { styles } from './tradesEdit.styles'
import { useHttpError } from '../../../hooks'

import { Currency } from '../../../api/Pioneer/model/Currency'
import { TradeListItemViewModel } from '../trades.model'
import { ErrorCodes, NonAuthRoutes } from '../../../model'
import { TradeForm, FormMode } from '../components/tradeForm/tradeForm'
import { cancelTokenSource } from '../../../api/Pioneer/endpoints/trades/trades.api'
import { useHistory } from 'react-router-dom'
import { isSimple, tradeSimpleSameDates } from '../helpers/trades.helper'
import { TRADES_TABS } from '../trades'

export interface TradeSimpleAddPageProps {}

export interface formDependencies {
  id?: number
  code?: string
  description?: string
  precioUnitario?: number
  marketType?: number
  commodity: number
  priceType: number
  redondeo?: number
  relatedFuturePrice?: number | null
  priceExpression?: string
  priceCalculationType?: EnumPriceCalculationType | null
}

export const TradesEditPage: React.FC<any> = props => {
  const [t] = useTranslation(['tradesEdit', 'globalerisLibrary', 'enums'])
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const history = useHistory()
  const { showError } = useHttpError()
  const trade: TradeListItemViewModel = props.location.state.trade
  const goBackTo = props.location.state.navigation

  const [isFetching, setIsFetching] = useState<boolean>(true)
  const [tradeDetails, setTradeDetails] = useState<TradeDetailsResponse | undefined>(undefined)
  //Ends General Page States

  const currentTab = props.location.state.currentTab as TRADES_TABS

  let countFetch = 0
  const fetchTradeDetailsById = async (id: number) => {
    setIsFetching(true)
    await getTradeDetails(id).then(response => {
      if (response.success && response.data) {
        const tradeDetailsResponse: TradeDetailsResponse = response.data
        setTradeDetails(tradeDetailsResponse)
        storeActiveTrade(tradeDetailsResponse)
        setIsFetching(false)
      } else {
        if (countFetch < 3) {
          countFetch += 1
          fetchTradeDetailsById(trade.id)
          return
        }
        setIsFetching(false)
        history.push(NonAuthRoutes.trades)
        response.error &&
          showError({
            title: t('tradeEdit:title'),
            errorCode: ErrorCodes.SERVER_ERROR
          })
      }
    })
  }

  // Simple trade is defined as a trade with only ONE position and ONE tract/tramo
  const tradeSimple = tradeDetails ? tradeSimpleSameDates(tradeDetails) : undefined

  useEffect(() => {
    fetchTradeDetailsById(trade.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  //#endregion

  return isFetching || !tradeDetails || tradeSimple === undefined ? (
    <Page fullWidth={false}>
      <PageHeader title={t('trades:title')}>
        <Button
          onClick={() => {
            cancelTokenSource()
            if (goBackTo) {
              history.push(goBackTo)
            } else {
              history.push(NonAuthRoutes.trades)
            }
          }}
          size="small"
          color="primary"
        >
          {t('tradesEdit:mainActions.back')}
        </Button>
      </PageHeader>
      <FormSkeleton withTitle={true} elevation={0} columns={1} inputs={9} />
    </Page>
  ) : (
    <TradeForm
      mode={FormMode.EDIT}
      tradeData={tradeDetails}
      simple={tradeSimple}
      currentTab={currentTab}
      goBackTo={goBackTo}
    />
  )
}
